/*
  "Share this post" (snippets/blog-share.liquid). The bubble works without this script; this adds:
  - Touch devices with the Web Share API: the phone's own share sheet instead of the bubble.
  - "Copy link" with a "Copied!" confirmation.
  - Close on outside click or Escape (focus returns to the button).
  - GA4 recommended `share` event to the GTM dataLayer: { method, content_type: 'article', item_id }.
*/
(function () {
  var touch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;

  function track(method, handle) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'share', method: method, content_type: 'article', item_id: handle });
  }

  document.querySelectorAll('[data-pwb-share]').forEach(function (share) {
    var summary = share.querySelector('summary');
    var url = share.getAttribute('data-url');
    var title = share.getAttribute('data-title');
    var handle = share.getAttribute('data-handle');
    var status = share.querySelector('[data-pwb-share-status]');
    var copyItem = share.querySelector('[data-pwb-share-copy-item]');
    var copyBtn = share.querySelector('[data-pwb-share-copy]');
    var copyLabel = share.querySelector('[data-pwb-share-copy-label]');

    summary.setAttribute('aria-expanded', 'false');
    share.addEventListener('toggle', function () { summary.setAttribute('aria-expanded', String(share.open)); });

    // Phones and tablets: hand off to the native share sheet
    if (touch && navigator.share) {
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        navigator.share({ title: title, url: url })
          .then(function () { track('native', handle); })
          .catch(function () { /* cancelled: do nothing */ });
      });
    }

    // Copy link (needs JS, so it's hidden in the markup until here).
    // Falls back to execCommand where the Clipboard API is missing or blocked (some in-app browsers).
    function legacyCopy() {
      var field = document.createElement('textarea');
      field.value = url;
      field.setAttribute('readonly', '');
      field.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
      document.body.appendChild(field);
      field.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(field);
      return ok;
    }
    function copied(ok) {
      copyLabel.textContent = ok ? 'Copied!' : 'Copy failed';
      status.textContent = ok ? 'Link copied to clipboard' : 'Could not copy the link';
      if (ok) track('copy_link', handle);
      setTimeout(function () { copyLabel.textContent = 'Copy link'; status.textContent = ''; }, 2000);
    }
    if (copyItem) {
      copyItem.hidden = false;
      copyBtn.addEventListener('click', function () {
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(url).then(function () { copied(true); }, function () { copied(legacyCopy()); });
        } else {
          copied(legacyCopy());
        }
      });
    }

    share.querySelectorAll('a[data-method]').forEach(function (a) {
      a.addEventListener('click', function () {
        track(a.getAttribute('data-method'), handle);
        share.open = false;
      });
    });

    document.addEventListener('click', function (e) {
      if (share.open && !share.contains(e.target)) share.open = false;
    });
    share.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && share.open) { share.open = false; summary.focus(); }
    });
  });
})();
